import React from "react";
import "./Legal.css";

export default function Legal() {
  return (
    <div className="legal-page">
      <header className="legal-hero">
        <div>
          <p className="legal-kicker">Legal</p>
          <h1 className="legal-title">Conditions generales & Confidentialite</h1>
          <p className="legal-subtitle">
            Ce document couvre les conditions d'utilisation (CGU) et la politique de confidentialite.
          </p>
        </div>
      </header>

      <section className="legal-section" id="cgu">
        <h2>Conditions generales d'utilisation (CGU)</h2>
        <div className="legal-card">
          <h3>1. Objet</h3>
          <p>
            Le service permet de generer des propositions de decoration interieure a partir de photos
            et de references. Ces propositions sont fournies a titre indicatif.
          </p>
          <h3>2. Acces au service</h3>
          <p>
            L'acces peut necessiter la creation d'un compte. L'utilisateur est responsable des informations
            transmises et de la securite de ses identifiants.
          </p>
          <h3>3. Credits & facturation</h3>
          <p>
            Les generations consomment des credits. Les packs et abonnements peuvent evoluer. Les credits
            achetes ne sont pas remboursables sauf obligation legale.
          </p>
          <h3>4. Propriete intellectuelle</h3>
          <p>
            Les contenus generes peuvent etre utilises dans le cadre des projets de l'utilisateur. Les
            ressources internes et le service restent la propriete de l'editeur.
          </p>
          <h3>5. Responsabilite</h3>
          <p>
            L'editeur ne saurait etre tenu responsable des decisions finales d'achat, travaux ou
            modifications basees sur des propositions generees par l'IA.
          </p>
        </div>
      </section>

      <section className="legal-section" id="privacy">
        <h2>Politique de confidentialite (RGPD)</h2>
        <div className="legal-card">
          <h3>1. Donnees collecte</h3>
          <p>
            Nous collectons les informations strictement necessaires au fonctionnement du service
            (email, identifiant, projets, medias envoyes).
          </p>
          <h3>2. Finalites</h3>
          <p>
            Les donnees sont utilisees pour authentifier, fournir le service, facturer si besoin,
            et ameliorer les performances.
          </p>
          <h3>3. Duree de conservation</h3>
          <p>
            Les donnees sont conservees tant que le compte est actif. L'utilisateur peut demander
            la suppression de son compte et de ses donnees.
          </p>
          <h3>4. Vos droits</h3>
          <p>
            Vous disposez d'un droit d'acces, de rectification, d'opposition et de suppression.
            Contact: support@contentos.ai
          </p>
          <h3>5. Cookies</h3>
          <p>
            Des cookies techniques peuvent etre utilises pour assurer le fonctionnement et la
            securite des sessions.
          </p>
        </div>
      </section>
    </div>
  );
}
